import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logo from "../../../images/big/logo.png";
import logoText from "../../../images/logo-text.png";

export function  NavMenuToggle(){
	setTimeout(()=>{	
		let mainwrapper = document.querySelector("#main-wrapper");
		if(mainwrapper.classList.contains('menu-toggle')){
			mainwrapper.classList.remove("menu-toggle");
		}else{
			mainwrapper.classList.add("menu-toggle");
		}
	},200);
}

const NavHader = () => {
   const [toggle, setToggle] = useState(false);

   return (
      <div className="nav-header">
         <Link to={"#"} className="brand-logo">
            <img className="logo-abbr" src={logo} alt="WATCHO" style={{ display: 'block', margin: '0 auto', maxWidth: '80%' }} />
            <img className="logo-compact" src={logoText} alt="WATCHO" />
         </Link>

         <div className="nav-control" onClick={() => 
               {
                  setToggle(!toggle)
                  NavMenuToggle();
               }}
            >
            <div className={`hamburger ${toggle ? "is-active" : ""}`}>
               <span className="line"></span>
               <span className="line"></span>
               <span className="line"></span>
            </div>
         </div>
      </div>
   );
};

export default NavHader;
